module.exports = __webpack_public_path__ + "static/condo_design-3-9f02561aba855ce175ba0f4cd297ccb8.jpg";